import React from 'react'

const Clearbit = () => (
  <svg width="79" height="24" viewBox="0 0 79 24" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <path d="M11.52 0v11.52h11.52V3.6a3.6 3.6 0 0 0-3.6-3.6h-7.92z" fill="#5CA4FF" opacity=".9"/>
        <path d="M0 11.52v7.92a3.6 3.6 0 0 0 3.6 3.6h7.92V11.52H0z" fill="#499AFF"/>
        <path d="M11.52 11.52v11.52h7.92a3.6 3.6 0 0 0 3.6-3.6v-7.92H11.52z" fill="#E9F3FF"/>
        <path d="M3.6 0A3.6 3.6 0 0 0 0 3.6v7.92h11.52V0H3.6z" fill="#499AFF"/>
      </g>
      <text fill="#499AFF" fontFamily="AvenirNext-Medium, Avenir Next" fontSize="12.6" fontWeight="400">
        <tspan x="32.4" y="15.25">Clearbi</tspan>
      </text>
      <text fill="#499AFF" fontFamily="AvenirNext-Medium, Avenir Next" fontSize="12.6" fontWeight="400">
        <tspan x="74.362" y="15.25">t</tspan>
      </text>
    </g>
  </svg>
)

export default Clearbit



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/CompanyInfo/CompanyInfoProvider/Icons/Clearbit.js